import crud_actions from './crud_actions'

export const CLEAR_SUGGESTIONS = 'clear_suggestions'

export const clearSuggestions = opts => {
  return {
    type: CLEAR_SUGGESTIONS,
    payload: opts
  }
}

export const suggestUsers = crud_actions.read('mentions', 'suggestUsers')
